import { useLocation, useNavigate } from "react-router-dom";

import Card from "components/Card";
import Switch from "components/Switch";

import { useActiveSubscription } from "routes/data-routes/billing-data/active-subscription";
import { useNextHigherPlan } from "v2/hooks/billing/pricing-options/useNextHigherPlan";
import { useAutoUpgradePrompt } from "routes/data-routes/billing-data/pricing-options/hooks/useAutoUpgradePrompt";
import { usePricingOptions } from "routes/data-routes/billing-data/pricing-options";

import { fmtCurrency, fmtShortNumber } from "utils";


export function PricingOptionsCard() {
  const { activeSubscription } = useActiveSubscription();
  const { nextHigherPlan } = useNextHigherPlan();
  const autoUpgradePrompt = useAutoUpgradePrompt();

  const { pricingOptions } = usePricingOptions();
  const paygOptions = pricingOptions?.["pay-as-you-go"];

  const navigate = useNavigate();
  const location = useLocation();


  if (
    (!pricingOptions?.["pay-as-you-go"]?.allowed || !activeSubscription?.capabilities?.payAsYouGo)
    && (
      !pricingOptions?.["auto-upgrade"]?.allowed
      || !activeSubscription?.autoUpgradeAllowed
      || !activeSubscription?.capabilities?.autoUpgrade
    )
  ) {
    return <></>;
  }

  return (
    <div className="pt-4 w-full">
      <Card
        title={
          <div className="flex flex-col items-start gap-y-1">
            <span className="font-semibold">Manage credits limitations</span>
            <span className="text-xs font-normal text-neutral-700">Manage what happens when your plan credits run out during your billing cycle</span>
          </div>
        }
        className="w-full bg-neutral-50"
      >
        <div className="flex flex-row gap-x-8">
          { pricingOptions?.["auto-upgrade"]?.allowed && activeSubscription?.autoUpgradeAllowed && activeSubscription?.capabilities?.autoUpgrade && (
            <div className="flex flex-col items-start gap-y-4 mt-2 w-auto">
              <Switch
                label={ autoUpgradePrompt }
                className="flex flex-row-reverse gap-x-2"
                checked={ pricingOptions?.["auto-upgrade"]?.enabled }
                onChange={ (autoUpgrade) => {
                  navigate(autoUpgrade ?"auto-upgrade/enable" : "auto-upgrade/disable", {
                    state: { backgroundLocation: location },
                    viewTransition: true
                  });
                } }
              />
              <div className="text-xs font-normal text-neutral-700">When you hit your { fmtShortNumber(activeSubscription?.apiCreditLimit || 0) } request limit, move to the { nextHigherPlan ? nextHigherPlan.planName : "next" } plan automatically.</div>
            </div>
          ) }

          { pricingOptions?.["pay-as-you-go"]?.allowed && activeSubscription?.capabilities?.payAsYouGo && (
            <div className="flex flex-col items-start gap-y-4 mt-2 w-auto">
              <Switch
                label={
                  <div className="flex flex-row gap-x-2 items-baseline">
                    Pay-as-you-go
                    { paygOptions?.enabled && paygOptions.creditsCap !== undefined && (
                      <span className="text-xs">(cap: { fmtCurrency(Math.ceil((paygOptions.creditsCap * 0.60) / 1000)) })</span>
                    ) }
                  </div>
                }
                className="flex flex-row-reverse gap-x-2"
                name="pay-as-you-go"
                checked={ paygOptions?.enabled }
                onChange={ (payAsYouGo) => {
                  navigate(payAsYouGo ? "pay-as-you-go/enable" : "pay-as-you-go/change", {
                    state: { backgroundLocation: location },
                    viewTransition: true
                  });
                }}
              />
              <div className="text-xs font-normal text-neutral-700">Stay on the { activeSubscription?.planName } Plan and just pay for extra usage beyond your included credits.</div>
            </div>
          ) }
        </div>
      </Card>
    </div>
  );
}
